module.exports = __webpack_public_path__ + "about-us-b998e096/about-us-7ccfbb0b9f3f93cf70a4a5e08a9c1ce8.svg";